/**
 *
 * @typedef {{
 *  name: keyof import('./trivias').default,
 *  className: string,
 *  thumbnailEnabled: boolean,
 *  thumbnailTitle: string,
 *  thumbnail: string,
 *  dummy: string,
 *  icon: string,
 *  link: string,
 *  linkTarget: "_blank" | "_top",
 *  header: string | JSX.Element,
 *  headerBottom: boolean,
 *  body: string,
 *  revealEnabled: boolean,
 *  revealBody: string,
 *  revealLinkText: string,
 *  [key: string]: any
 * }} CommonTriviaProps
 *
 * @typedef {{
 *  getPosition: (props: CommonTriviaProps) => keyof import('./positions')
 *  Component: (props: CommonTriviaProps) => JSX.Element
 * }} TriviaDefinition
 *
 * @param {TriviaDefinition} param0
 */
export var defineTrivia = function defineTrivia(_ref) {
  var getPosition = _ref.getPosition,
    Component = _ref.Component;
  return {
    getPosition: getPosition,
    Component: Component
  };
};
//# sourceMappingURL=defineTrivia.js.map